module.exports = __webpack_public_path__ + "img/ring_r_o_null_1@3x.c18dde45.png";